import { useNavigate } from 'react-router';
import { ClockIcon } from '../../icons/clockIcon';
import { Button } from '../ui/Button';
import { mapStepToMessage, mapStepToText } from '../../utils/helper';

export const OfferCarCard = ({ carInfo }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col max-xl:border max-xl:border-[#6A6A6A] xl:bg-white p-6 rounded-[12px] max-w-[600px] max-xl:h-full">
      <div className="flex max-xl:flex-col max-xl:items-center">
        <div className="xl:hidden">
          <h3>{carInfo.carTitle}</h3>
          <p className="text-[#6A6A6A] text-disclaimer">
            {carInfo.carSubTitle}
          </p>
        </div>
        <img
          alt={carInfo.carTitle}
          className="xl:max-w-[260px] xl:h-[130px]"
          src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${
            carInfo.carTitle.split(' ')[0]
          }&modelFamily=${carInfo.carTitle.split(' ')[1]}&modelVariant=${
            carInfo.carTitle.split(' ')[1]
          }&modelYear=${
            carInfo.ModelYear
          }&powerTrain=hybrid&trim=eu&zoomType=fullScreen&width=400&angle=28&aspectRatio=20:10`}
        />
        <div className="flex flex-col gap-6 max-xl:hidden">
          <div>
            <h3 title={carInfo.carTitle} className='w-[180px] truncate'>{carInfo.carTitle}</h3>
            <p title={carInfo.carSubTitle} className="text-[#6A6A6A] text-disclaimer w-[200px] truncate">
              {carInfo.carSubTitle}
            </p>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <ClockIcon />
              <h5>Σε εξέλιξη</h5>
            </div>
            <p className="text-[#6A6A6A] text-disclaimer pl-1">
              {carInfo.state.step !== 9 && 'Εκκρεμεί: '}
              <b className="text-black">
                {carInfo.state.step === 9
                  ? mapStepToMessage(
                      carInfo.state.step,
                      carInfo.state.substatus
                    ) || carInfo.state.message
                  : mapStepToText(carInfo.state.step)}
              </b>
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <div>
          <h6>{carInfo.installment.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€/μήνα </h6>
          <p className="text-[#6A6A6A] text-disclaimer">
            {(carInfo.installment * carInfo.VATTax).toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€ με ΦΠΑ 24%
          </p>
        </div>
        <div className="flex gap-5">
          <div>
            <p className="text-[#6A6A6A] text-disclaimer">Κωδικός Προσφοράς</p>
            <h6>{carInfo.cncode}</h6>
          </div>
          {!carInfo.isLegacy &&  carInfo.source === 'intermediate' && (
            <Button
              className={
                'rounded-[6px] bg-[#D4002A] text-white px-10 py-3 h6 max-xl:hidden'
              }
              onClick={() => {
                navigate(`/track-your-car/details/${carInfo.cncode}`);
              }}
            >
              Ολοκλήρωση
            </Button>
          )}
        </div>
      </div>
      <div className="xl:hidden mt-4">
        <div className="flex items-center gap-2 pb-2">
          <ClockIcon />
          <h5>Σε εξέλιξη</h5>
        </div>
        <p className="text-start text-[#6A6A6A] text-disclaimer text-center">
          Εκκρεμεί:{' '}
          <b className="text-black">
            {carInfo.state.step === 9
              ? mapStepToMessage(carInfo.state.step, carInfo.state.substatus) ||
                carInfo.state.message
              : mapStepToText(carInfo.state.step)}
          </b>
        </p>
      </div>
      {!carInfo.isLegacy &&  carInfo.source === 'intermediate' && (
        <Button
          className={
            'rounded-[6px] bg-[#D4002A] text-white mt-4 px-10 py-3 h6 xl:hidden'
          }
          onClick={() => {
            navigate(`/track-your-car/details/${carInfo.cncode}`);
          }}
        >
          Ολοκλήρωση
        </Button>
      )}
    </div>
  );
};
